import type { DataGridColumnSettings, DropDownNoSelection, DropDownResult } from '@myosh/odin-components';
import type {
  ExtendedDynamicFormSettings,
  ExtendedDynamicFormWorkflowStep,
  RecordLinkType,
} from '../../../../../@types/forms';

export const SelectingGridType = {
  ALL_RECORDS_GRID: 0,
  SELECTED_RECORDS_GRID: 1,
} as const;
export type SelectingGridType = (typeof SelectingGridType)[keyof typeof SelectingGridType];

export interface LinkedRecordsSelectingProps {
  recordId: number | undefined;
  sourceModuleFormId?: number;
  targetModuleFormId?: number;
  recordLinkType?: RecordLinkType;
  formId?: number;
  value: Array<string>;
  linkedWorkflowSteps?: Array<ExtendedDynamicFormWorkflowStep>;
  formSettings?: ExtendedDynamicFormSettings;
  updatePreviewRecord?: (recordId?: number) => void;
  selectedLastEditedFilter: DropDownResult;
  selectedConfig?: DropDownResult | DropDownNoSelection;
  selectedRecordsFilter: DropDownResult;
  setSelectedRecords: (records: Array<string>) => void;
  previewRecordId?: string;
}

export const getColumnsConfigurator = (linkedRecordsGrid: SelectingGridType = SelectingGridType.ALL_RECORDS_GRID) => {
  const isAllRecordsGrid = linkedRecordsGrid === SelectingGridType.ALL_RECORDS_GRID;
  return (configColumn: DataGridColumnSettings) => {
    const column: DataGridColumnSettings = {
      ...configColumn,
      searchType: isAllRecordsGrid ? configColumn.searchType : undefined,
      isIdField: 'id' === configColumn.field.toLowerCase(),
    };

    if (configColumn.searchType === 'MultiSelect' || configColumn.searchType === 'SingleSelect') {
      column.dropDownValue = 'id';
      column.dropDownText = 'caption';
    }

    return column;
  };
};
